export const report_type = [
    {
        name: 'Open orders details',
        value: 'OPEN_ORDER',
        fileName: 'Open_Order_List_',
        fileKey: "",
        status: 'NOT_GENERATED',
        downloadLabel: 'Download'
    },
    {
        name: 'SKU level invoice report',
        value: 'SKU_LEVEL_INVOICE',
        fileName: 'Sku_Level_Invoice_Report_',
        fileKey: "",
        status: 'NOT_GENERATED',
        downloadLabel: 'Download'
    }
];

export const json_excel_invoice =    {
    name: 'JSON/Excel format for generating E-invoice',
    value: 'E_INVOICE',
    fileName: 'E_Invoice',
    fileKey: '',
    status: '',
    downloadLabel: 'Download'
}

export const e_invoice_file_types = [
    {
        id: '1',
        type: 'json',
        value: 'JSON'
    },
    {
        id: '2',
        type: 'excel',
        value: 'EXCEL'
    },
]
